import { useState } from "react";
import { Image } from "lucide-react";
import { assetService } from "../../assets";
import type { EditorAsset } from "../editor.types";
import { SampleArtwork } from "./SampleArtwork";

export function WorkThumbnail({
  picture,
  asset,
}: {
  picture: import("./workDetails").CoverPicture | null;
  asset?: EditorAsset;
}) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const url = asset ? assetService.getPublicUrl(asset.storage_path) : null;
  const sample = (picture?.content as { sample?: string } | undefined)?.sample;
  return (
    <span className="grid size-13 flex-none place-items-center overflow-hidden rounded-lg bg-hazumu-border text-hazumu-muted [&_.sample-artwork]:size-full [&_.sample-artwork]:rounded-none [&_.sample-artwork_span]:text-[15px]" aria-hidden="true">
      {url && url !== failedUrl ? (
        <img
          className="size-full object-cover"
          src={url}
          alt=""
          loading="lazy"
          onError={() => setFailedUrl(url)}
        />
      ) : sample ? (
        <SampleArtwork kind={sample} />
      ) : (
        <Image size={22} strokeWidth={1.5} />
      )}
    </span>
  );
}
